import { apiRequestActions } from '@ackee/redux-utils';
import { fetchMaintenancesTypes } from './types';

export default apiRequestActions(fetchMaintenancesTypes);
